import { Inject, Injectable } from '@angular/core';
import { DwFieldAggregate, DwFieldType, DwOrmDataService, DwOrmDataServiceToken } from '@devwareapps/devware-cap';
import { Observable } from 'rxjs';
import { map, take, timeout } from 'rxjs/operators';
import { AppMetaData, RoUserFitnessStatsEntity } from '../../../meta-data/app-meta-data.service';

export interface OverallActivityTotals extends RoUserFitnessStatsEntity {
    SummaryCount?: number; ActivityCount?: number; DurationSeconds?: number; ActivityDays?: number;
}

@Injectable({providedIn:'root'})
export class OverallStatsService {
    constructor(@Inject(DwOrmDataServiceToken) private orm: DwOrmDataService) {}
    loadChallengeTotals(challengeId: number): Observable<OverallActivityTotals> {
        const query = AppMetaData.RoUserFitnessStats.CreateQueryBuilder().setupAggregateQuery()
            .addField(a => ({FullFieldName:a.UserFitnessSummaryId.fieldNameWithItemPrefix, FieldAlias:'SummaryCount', FieldType:DwFieldType.Aggregate, AggregateFunction:DwFieldAggregate.Count}))
            .addField(a => ({FullFieldName:a.TotalActivities.fieldNameWithItemPrefix, FieldAlias:'ActivityCount', FieldType:DwFieldType.Aggregate, AggregateFunction:DwFieldAggregate.Sum}))
            .addField(a => ({FullFieldName:a.TotalDurationSeconds.fieldNameWithItemPrefix, FieldAlias:'DurationSeconds', FieldType:DwFieldType.Aggregate, AggregateFunction:DwFieldAggregate.Sum}))
            .addField(a => ({FullFieldName:a.TotalExerciseDays.fieldNameWithItemPrefix, FieldAlias:'ActivityDays', FieldType:DwFieldType.Aggregate, AggregateFunction:DwFieldAggregate.Sum}))
            .addFilterAnd(f => f.Equal(a => a.ChallengeDefinitionId, challengeId));
        return this.orm.executeQuery<OverallActivityTotals>(query).pipe(timeout(30000),take(1),map(rows=>rows[0] || AppMetaData.RoUserFitnessStats.CreateEntity()));
    }
}
